import styled from 'styled-components';

export const Register = styled.div`
	margin: 0 auto 0;
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const Wrapper = styled.div`
	font-family: 'Arimo', sans-serif;
	background-size: 100%;
	display: flex;
	justify-content: center;
	flex-direction: column;
	align-items: center;
	height: 100%;
	background: #111111;

	p {
		text-align: center;
		color: #ffffff;
		font-size: 13px;
	}

	a {
		&:hover,
		&:visited,
		&:hover,
		&:link {
			color: rgba(255, 255, 255, 0.6);
		}
	}
`;

export const Input = styled.input`
		width: 100%;
		border-radius: 6px;
		height: 70px;
		border: 0;
		padding: 10px;
		padding: 20px 0 0 16px;
		font-size: 0;
		background: #000000;
		transition: background .3s ease;
		color: #ffffff;

	&:focus {
			background: #222222;
			font-size: 23px;

		&::selection {
				background: rgba(188, 188, 188, 0.5);
			}
		}
	&.active {
			background: #065CB7;
			font-size: 23px;
		}
	}
`;

export const Field = styled.div`
	width: 385px;
	height: 70px;
	position: relative;
	input {
		position: absolute;
		height: 70px;
	}
	
	input:focus + label {
		font-size: 19px;
		transform: translate(16px, 11px);
		color: rgba(255, 255, 255, 0.7);
	}

	input:focus + label + button {
		opacity: 1;
	}
}`;

export const Label = styled.label`
	position: absolute;
	color: rgba(255, 255, 255, 1);
	transform: translate(16px, 20px);
	transition: transform 0.3s ease, font-size 0.3s ease, color 0.3s 0.1s ease;
	font-size: 28px;
	&.active {
		font-size: 19px;
		transform: translate(16px, 11px);
		color: rgba(255, 255, 255, 0.7);
	}
`;

export const Button = styled.button`
	right: 0;
	border: 0;
	position: absolute;
	height: 50px;
	margin: 10px;
	width: 115px;
	border-radius: 6px;
	font-size: 22px;
	cursor: pointer;
	transition: width 0.3s ease, background 0.3s ease, opacity 0.3s ease;
	opacity: 0;
	background: ${({ active }) => (active ? `#111111` : `#00000011`)};
	color: ${({ active }) => (active ? `#FFFFFF` : `#FFFFFF11`)};
	text-transform: uppercae;
	pointer-events: none;

	opacity: 1;
	pointer-events: auto;
	&:hover {
		background: ${({ active }) => (active ? `#FFFFFF` : `#00000011`)};
		color: ${({ active }) => (active ? `#111111` : `#FFFFFF11`)};
	}
`;



// WEBPACK FOOTER //
// ./src/containers/Password/styles.js